import { formatUnit } from "../lib/formatUnit";

const formatQty = (v) => (v == null ? "\u2014" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: 4 }));
const formatDateTime = (iso) => {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "\u2014" : d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// The NPD team's own consumption slip - the paper copy of material leaving the
// NPD godown for a cost centre, matching RequestPrintSlip's layout so the
// request copy and this one read the same way.
export const NpdConsumptionSlip = ({ posting }) => {
  if (!posting) return null;
  return (
    <div className="hidden print:block print:fixed print:top-0 print:left-0 print:w-full print:bg-white p-10 text-[13px] text-[#101828]" style={{ fontFamily: "'DM Sans', sans-serif" }} data-testid="npd-consumption-print-slip">
      <style>{"@media print { @page { margin: 0; size: auto; } }"}</style>
      <div className="flex justify-between items-start">
        <div />
        <div className="text-right">
          <h1 className="text-2xl font-bold tracking-wide">NPD Consumption</h1>
          <p className="text-xs text-[#667085] mt-1">Page 1 of 1</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-y-2 gap-x-10 mt-8 text-sm">
        <div><span className="font-bold">Posting ID :</span> {posting._id}</div>
        <div><span className="font-bold">SAP Confirmation :</span> {posting.sap_gac_id || "\u2014"}</div>
        <div><span className="font-bold">Issued By :</span> {posting.submitted_by}</div>
        <div><span className="font-bold">Site :</span> {posting.site_id}</div>
        <div><span className="font-bold">Issued From :</span> {(posting.lines || [])[0]?.logistics_area_id || "\u2014"}</div>
        <div><span className="font-bold">Cost Centre :</span> {posting.cost_center_id || "\u2014"}</div>
        <div><span className="font-bold">Old Customer :</span> {posting.customer_name ? `${posting.customer_name}${posting.customer_id ? ` (${posting.customer_id})` : ""}` : "\u2014"}</div>
        <div><span className="font-bold">New Customer :</span> {posting.new_customer_name || "\u2014"}</div>
        <div><span className="font-bold">Date :</span> {formatDateTime(posting.posted_at || posting.created_at)}</div>
        <div><span className="font-bold">Status :</span> {posting.status}</div>
        <div className="col-span-2"><span className="font-bold">Project / Remark :</span> {posting.project_remark || posting.remarks || "\u2014"}</div>
      </div>
      <table className="w-full mt-8 border-collapse">
        <thead>
          <tr className="bg-[#F2F4F7]">
            {["Serial No", "Product ID", "Issued From", "Consumed Qty"].map((h) => (
              <th key={h} className="border border-[#101828] px-2 py-1.5 text-left text-xs font-bold">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(posting.lines || []).map((l, i) => (
            <tr key={`${l.product_id}-${i}`}>
              <td className="border border-[#101828] px-2 py-1.5 text-center">{i + 1}</td>
              <td className="border border-[#101828] px-2 py-1.5 font-mono">{l.product_id}</td>
              <td className="border border-[#101828] px-2 py-1.5 font-mono">{l.logistics_area_id}</td>
              <td className="border border-[#101828] px-2 py-1.5">{formatQty(l.quantity)} {formatUnit(l.quantity_uom)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-between mt-20 text-xs text-[#667085]">
        <div className="border-t border-[#101828] pt-1 w-56">NPD Sign / Date</div>
        <div className="border-t border-[#101828] pt-1 w-56 text-right">Store Sign / Date</div>
      </div>
    </div>
  );
};
